import auth from '@/store/modules/auth/auth'
import order from '@/store/modules/order/order'
import orderMyProduct from '@/store/modules/order/product'

export default {
  auth,
  order,
  orderMyProduct
}
